'use strict';

export default {
    data() {
        return {
            labelDays: '',
            labelHours: '',
            labelMinutes: '',
            labelSeconds: '',
            countStarted: false,
            countdownFinished: false,
            types: {
                days: null,
                hours: null,
                minutes: null,
                seconds: null,
            }
        };
    },
    methods: {
        getCountdownLabel({type, label} = {}) {
            const lang = document.getElementsByTagName('html')[0].getAttribute('lang');
            let labels = {
                days: 'days',
                day: 'day',
                hours: 'hrs',
                hour: 'hr',
                minutes: 'mins',
                minute: 'min',
                seconds: 'secs',
                second: 'sec'
            };

            if (lang === 'fr') {
                labels = {
                    days: 'jours',
                    day: 'jour',
                    hours: 'hrs',
                    hour: 'hr',
                    minutes: 'mins',
                    minute: 'min',
                    seconds: 'secs',
                    second: 'sec'
                };
            }

            switch (label) {
                case 'days':
                    this.labelDays = labels.days;

                    if (type <= 1) {
                        this.labelDays = labels.day;
                    }
                break;
                case 'hours':
                    this.labelHours = labels.hours;

                    if (type <= 1) {
                        this.labelHours = labels.hour;
                    }
                break;
                case 'minutes':
                    this.labelMinutes = labels.minutes;

                    if (type <= 1) {
                        this.labelMinutes = labels.minute;
                    }
                break;
                case 'seconds':
                    this.labelSeconds = labels.seconds;

                    if (type <= 1) {
                        this.labelSeconds = labels.second;
                    }
                break;
                default:
                break;
            }
        }
    }
};